export default __webpack_public_path__ + "static/media/img2.f1ff2311.svg";